<label class="is-checkbox" [appTooltip]="tooltip()" [class.disabled]="!enabled()">
	@if (labelPosition() === CheckboxLabelPosition.LEFT) {
		<span>{{ label() }}</span>
	}
	<span class="checkbox-input">
		<input
			#checkbox
			type="checkbox"
			[checked]="valueAsBoolean()"
			(change)="valueChange.emit(checkbox.checked)"
			[disabled]="!(enabled() ?? true)"
		/>
		@if (checkboxIcon(); as iconName) {
			<app-icon [name]="iconName" [color]="checkboxIconColor()" size="small" class="checkbox-icon"></app-icon>
		}
	</span>
	@if (labelPosition() === CheckboxLabelPosition.RIGHT) {
		<span>{{ label() }}</span>
	}
</label>
